import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { ExternalLink } from 'lucide-react';

const pinIcon = L.icon({
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41],
});

// Small, non-scrolling Leaflet map that just shows a single service-location pin.
const PinMap = ({ lat, lng, height = '11rem', zoom = 15, testId = 'pin-map' }) => {
  const mapRef = useRef(null);
  const mapObj = useRef(null);

  useEffect(() => {
    if (!mapRef.current || mapObj.current || lat == null || lng == null) return;
    mapObj.current = L.map(mapRef.current, { scrollWheelZoom: false, dragging: true, zoomControl: true })
      .setView([lat, lng], zoom);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '© OpenStreetMap' }).addTo(mapObj.current);
    L.marker([lat, lng], { icon: pinIcon }).addTo(mapObj.current).bindPopup('Service location');
    setTimeout(() => mapObj.current && mapObj.current.invalidateSize(), 200);
    return () => { if (mapObj.current) { mapObj.current.remove(); mapObj.current = null; } };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mapObj.current && lat != null && lng != null) mapObj.current.setView([lat, lng], zoom);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lat, lng]);

  if (lat == null || lng == null) return null;

  const gmaps = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;

  return (
    <div data-testid={testId}>
      <div ref={mapRef} style={{ height }} className="w-full rounded-lg overflow-hidden border border-gray-200 z-0" />
      <a
        href={gmaps}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-blue-600 hover:text-blue-800"
        data-testid={`${testId}-open-gmaps`}
      >
        <ExternalLink className="w-3.5 h-3.5" /> Open in Google Maps
      </a>
    </div>
  );
};

export default PinMap;
